import { render, staticRenderFns } from "./NewModal.vue?vue&type=template&id=2d800e65&scoped=true&"
var script = {}
import style0 from "./NewModal.vue?vue&type=style&index=0&id=2d800e65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d800e65",
  null
  
)

export default component.exports